// extracted by mini-css-extract-plugin
export default {"charts_container":"styles_charts_container__4PuZ9","charts_item":"styles_charts_item__WS6F5","charts_item_graph":"styles_charts_item_graph__vBJDX"};